export default __webpack_public_path__ + "static/media/all.d060ea4b.svg";